import Api from "../apiService";

class integrationsApi {
  index(companyId) {
    return Api.getRequest(
      `companies/${companyId}/integrations`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/integrations`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, integrationId, data) {
    return Api.patchRequest(
      `companies/${companyId}/integrations/${integrationId}`,
      data,
      Api.authHeaders()
    );
  }

  destroy(companyId, integrationId) {
    return Api.deleteRequest(
      `companies/${companyId}/integrations/${integrationId}`,
      Api.authHeaders()
    );
  }

  enableIntegration(companyId, integrationId) {
    return Api.patchRequest(
      `companies/${companyId}/integrations/${integrationId}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disableIntegration(companyId, integrationId) {
    return Api.patchRequest(
      `companies/${companyId}/integrations/${integrationId}/disable`,
      {},
      Api.authHeaders()
    );
  }

  checkConnection(companyId, integrationId) {
    return Api.postRequest(
      `companies/${companyId}/integrations/${integrationId}/check`,
      {},
      Api.authHeaders()
    );
  }

  importVehicles(companyId, integrationId) {
    return Api.postRequest(
      `companies/${companyId}/integrations/${integrationId}/glonasssoft/import_vehicles`,
      { integration_id: integrationId },
      Api.authHeaders()
    );
  }
}

export default new integrationsApi();
